import * as api from '../api/rollCorrection';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const FETCH_ALL_ROLL_CORR_GROUPS = createRequestTypes(
  `${prefix}/FETCH_ALL_ROLL_CORR_GROUPS`,
);

export const FETCH_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/FETCH_ROLL_CORR_GROUP`,
);

export const UPDATE_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/UPDATE_ROLL_CORR_GROUP`,
);

export const DELETE_ROLL_CORR_FROM_GROUP = createRequestTypes(
  `${prefix}/DELETE_ROLL_CORR_FROM_GROUP`,
);

export const DELETE_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/DELETE_ROLL_CORR_GROUP`,
);

export const RECALCULATE_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/RECALCULATE_ROLL_CORR_GROUP`,
);

export const RECALCULATE_ROLL_CORR_GROUP_STATUS = createRequestTypes(
  `${prefix}/RECALCULATE_ROLL_CORR_GROUP_STATUS`,
);

export const LOCK_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/LOCK_ROLL_CORR_GROUP`,
);

export const UNLOCK_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/UNLOCK_ROLL_CORR_GROUP`,
);

export const TEMP_OPEN_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/TEMP_OPEN_ROLL_CORR_GROUP`,
);

export const FINALIZE_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/FINALIZE_ROLL_CORR_GROUP`,
);

export const UNFINALIZE_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/UNFINALIZE_ROLL_CORR_GROUP`,
);

export const EXPORT_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/EXPORT_ROLL_CORR_GROUP`,
);

export const ROLL_CORR_GROUP_EXPORT_STATUS = createRequestTypes(
  `${prefix}/ROLL_CORR_GROUP_EXPORT_STATUS`,
);

export const FETCH_TOTAL_RUNS = createRequestTypes(
  `${prefix}/FETCH_TOTAL_RUNS`,
);

export const FETCH_GROUP_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_GROUP_PROPERTIES`,
);

export const UPLOAD_FILE = createRequestTypes(`${prefix}/UPLOAD_FILE`);
export const DELETE_FILE = createRequestTypes(`${prefix}/DELETE_FILE`);
export const UPDATE_FILE = createRequestTypes(`${prefix}/UPDATE_FILE`);
export const DOWNLOAD_FILE = createRequestTypes(`${prefix}/DOWNLOAD_FILE`);

export const CREATE_TAX_LIMITATION_CALCULATION_RUN = createRequestTypes(
  `${prefix}/CREATE_TAX_LIMITATION_CALCULATION_RUN`,
);

export const FETCH_TAX_LIMITATION_CALCULATION_RUNS = createRequestTypes(
  `${prefix}/FETCH_TAX_LIMITATION_CALCULATION_RUNS`,
);

export const FETCH_TAX_LIMITATION_CALCULATION_RUN_PROPERTIES =
  createRequestTypes(
    `${prefix}/FETCH_TAX_LIMITATION_CALCULATION_RUN_PROPERTIES`,
  );

export const FETCH_TAX_LIMITATION_CALCULATION_RUN_ERRORS = createRequestTypes(
  `${prefix}/FETCH_TAX_LIMITATION_CALCULATION_RUN_ERRORS`,
);

export const FETCH_GROUP_RECAPTURES = createRequestTypes(
  `${prefix}/FETCH_GROUP_RECAPTURES`,
);

export const CREATE_GROUP_RECAPTURES = createRequestTypes(
  `${prefix}/CREATE_GROUP_RECAPTURES`,
);

export const FETCH_GROUP_RECAPTURE_ERRORS = createRequestTypes(
  `${prefix}/FETCH_GROUP_RECAPTURE_ERRORS`,
);

export const FETCH_GROUP_RECAPTURE_FREEZES = createRequestTypes(
  `${prefix}/FETCH_GROUP_RECAPTURE_FREEZES`,
);

export const UNDO_GROUP_RECAPTURE = createRequestTypes(
  `${prefix}/UNDO_GROUP_RECAPTURE`,
);

export const CREATE_ROLL_CORR_GROUP = createRequestTypes(
  `${prefix}/CREATE_ROLL_CORR_GROUP`,
);

export const FETCH_MASS_ROLL_CORRECTION_JOB_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_MASS_ROLL_CORRECTION_JOB_PROPERTIES`,
);

export const FETCH_MASS_ROLL_CORRECTION_JOB_PROCESSED = createRequestTypes(
  `${prefix}/FETCH_MASS_ROLL_CORRECTION_JOB_PROCESSED`,
);

export const fetchAllRollCorrGroups = makeApiActionCreatorV3(
  api.fetchAllRollCorrGroups,
  FETCH_ALL_ROLL_CORR_GROUPS[START],
  FETCH_ALL_ROLL_CORR_GROUPS[SUCCESS],
  FETCH_ALL_ROLL_CORR_GROUPS[ERROR],
);

export const fetchRollCorrGroup = makeApiActionCreatorV3(
  api.fetchRollCorrGroup,
  FETCH_ROLL_CORR_GROUP[START],
  FETCH_ROLL_CORR_GROUP[SUCCESS],
  FETCH_ROLL_CORR_GROUP[ERROR],
);

export const updateRollCorrGroup = makeApiActionCreatorV3(
  api.updateRollCorrGroup,
  UPDATE_ROLL_CORR_GROUP[START],
  UPDATE_ROLL_CORR_GROUP[SUCCESS],
  UPDATE_ROLL_CORR_GROUP[ERROR],
);

export const deleteRollCorrGroup = makeApiActionCreatorV3(
  api.deleteRollCorrGroup,
  DELETE_ROLL_CORR_GROUP[START],
  DELETE_ROLL_CORR_GROUP[SUCCESS],
  DELETE_ROLL_CORR_GROUP[ERROR],
);

export const deleteRollCorrFromGroup = makeApiActionCreatorV3(
  api.deleteRollCorrFromGroup,
  DELETE_ROLL_CORR_FROM_GROUP[START],
  DELETE_ROLL_CORR_FROM_GROUP[SUCCESS],
  DELETE_ROLL_CORR_FROM_GROUP[ERROR],
);

export const recalculateRollCorrGroup = makeApiActionCreatorV3(
  api.recalculateRollCorrGroup,
  RECALCULATE_ROLL_CORR_GROUP[START],
  RECALCULATE_ROLL_CORR_GROUP[SUCCESS],
  RECALCULATE_ROLL_CORR_GROUP[ERROR],
);

export const recalculateRollCorrGroupStatus = makeApiActionCreatorV3(
  api.recalculateRollCorrGroupStatus,
  RECALCULATE_ROLL_CORR_GROUP_STATUS[START],
  RECALCULATE_ROLL_CORR_GROUP_STATUS[SUCCESS],
  RECALCULATE_ROLL_CORR_GROUP_STATUS[ERROR],
);

export const lockRollCorrGroup = makeApiActionCreatorV3(
  api.lockRollCorrGroup,
  LOCK_ROLL_CORR_GROUP[START],
  LOCK_ROLL_CORR_GROUP[SUCCESS],
  LOCK_ROLL_CORR_GROUP[ERROR],
);

export const unlockRollCorrGroup = makeApiActionCreatorV3(
  api.unlockRollCorrGroup,
  UNLOCK_ROLL_CORR_GROUP[START],
  UNLOCK_ROLL_CORR_GROUP[SUCCESS],
  UNLOCK_ROLL_CORR_GROUP[ERROR],
);

export const tempOpenRollCorrGroup = makeApiActionCreatorV3(
  api.tempOpenRollCorrGroup,
  TEMP_OPEN_ROLL_CORR_GROUP[START],
  TEMP_OPEN_ROLL_CORR_GROUP[SUCCESS],
  TEMP_OPEN_ROLL_CORR_GROUP[ERROR],
);

export const finalizeRollCorrGroup = makeApiActionCreatorV3(
  api.finalizeRollCorrGroup,
  FINALIZE_ROLL_CORR_GROUP[START],
  FINALIZE_ROLL_CORR_GROUP[SUCCESS],
  FINALIZE_ROLL_CORR_GROUP[ERROR],
);

export const unfinalizeRollCorrGroup = makeApiActionCreatorV3(
  api.unfinalizeRollCorrGroup,
  UNFINALIZE_ROLL_CORR_GROUP[START],
  UNFINALIZE_ROLL_CORR_GROUP[SUCCESS],
  UNFINALIZE_ROLL_CORR_GROUP[ERROR],
);

export const uploadFile = makeApiActionCreatorV3(
  api.uploadFile,
  UPLOAD_FILE[START],
  UPLOAD_FILE[SUCCESS],
  UPLOAD_FILE[ERROR],
);

export const deleteFile = makeApiActionCreatorV3(
  api.deleteFile,
  DELETE_FILE[START],
  DELETE_FILE[SUCCESS],
  DELETE_FILE[ERROR],
);

export const updateFile = makeApiActionCreatorV3(
  api.updateFile,
  UPDATE_FILE[START],
  UPDATE_FILE[SUCCESS],
  UPDATE_FILE[ERROR],
);

export const downloadFile = makeApiActionCreatorV3(
  api.downloadFile,
  DOWNLOAD_FILE[START],
  DOWNLOAD_FILE[SUCCESS],
  DOWNLOAD_FILE[ERROR],
);

export const exportRollCorrGroup = makeApiActionCreatorV3(
  api.exportRollCorrGroup,
  EXPORT_ROLL_CORR_GROUP[START],
  EXPORT_ROLL_CORR_GROUP[SUCCESS],
  EXPORT_ROLL_CORR_GROUP[ERROR],
);

export const fetchRollCorrGroupExportStatus = makeApiActionCreatorV3(
  api.fetchRollCorrGroupExportStatus,
  ROLL_CORR_GROUP_EXPORT_STATUS[START],
  ROLL_CORR_GROUP_EXPORT_STATUS[SUCCESS],
  ROLL_CORR_GROUP_EXPORT_STATUS[ERROR],
);

export const fetchTotalRuns = makeApiActionCreatorV3(
  api.fetchTotalRuns,
  FETCH_TOTAL_RUNS[START],
  FETCH_TOTAL_RUNS[SUCCESS],
  FETCH_TOTAL_RUNS[ERROR],
);

export const fetchGroupProperties = makeApiActionCreatorV3(
  api.fetchGroupProperties,
  FETCH_GROUP_PROPERTIES[START],
  FETCH_GROUP_PROPERTIES[SUCCESS],
  FETCH_GROUP_PROPERTIES[ERROR],
);

export const fetchTaxLimitationCalculationRuns = makeApiActionCreatorV3(
  api.fetchTaxLimitationCalculationRuns,
  FETCH_TAX_LIMITATION_CALCULATION_RUNS[START],
  FETCH_TAX_LIMITATION_CALCULATION_RUNS[SUCCESS],
  FETCH_TAX_LIMITATION_CALCULATION_RUNS[ERROR],
);

export const fetchTaxLimitationCalculationRunProperties =
  makeApiActionCreatorV3(
    api.fetchTaxLimitationCalculationRunProperties,
    FETCH_GROUP_RECAPTURE_FREEZES[START],
    FETCH_GROUP_RECAPTURE_FREEZES[SUCCESS],
    FETCH_GROUP_RECAPTURE_FREEZES[ERROR],
  );

export const fetchTaxLimitationCalculationRunErrors = makeApiActionCreatorV3(
  api.fetchTaxLimitationCalculationRunErrors,
  FETCH_GROUP_RECAPTURE_ERRORS[START],
  FETCH_GROUP_RECAPTURE_ERRORS[SUCCESS],
  FETCH_GROUP_RECAPTURE_ERRORS[ERROR],
);

export const createTaxLimitationCalculationRun = makeApiActionCreatorV3(
  api.createTaxLimitationCalculationRun,
  CREATE_TAX_LIMITATION_CALCULATION_RUN[START],
  CREATE_TAX_LIMITATION_CALCULATION_RUN[SUCCESS],
  CREATE_TAX_LIMITATION_CALCULATION_RUN[ERROR],
);

export const fetchGroupRecaptures = makeApiActionCreatorV3(
  api.fetchGroupRecaptures,
  FETCH_GROUP_RECAPTURES[START],
  FETCH_GROUP_RECAPTURES[SUCCESS],
  FETCH_GROUP_RECAPTURES[ERROR],
);

export const createGroupRecaptures = makeApiActionCreatorV3(
  api.createGroupRecaptures,
  CREATE_GROUP_RECAPTURES[START],
  CREATE_GROUP_RECAPTURES[SUCCESS],
  CREATE_GROUP_RECAPTURES[ERROR],
);

export const fetchGroupRecaptureErrors = makeApiActionCreatorV3(
  api.fetchGroupRecaptureErrors,
  FETCH_GROUP_RECAPTURE_ERRORS[START],
  FETCH_GROUP_RECAPTURE_ERRORS[SUCCESS],
  FETCH_GROUP_RECAPTURE_ERRORS[ERROR],
);

export const CHANGE_PAGE_RECAPTURE_ERRORS = `${prefix}/CHANGE_PAGE_RECAPTURE_ERRORS`;

export const changePageRecaptureErrors = (page) => ({
  type: CHANGE_PAGE_RECAPTURE_ERRORS,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE_RECAPTURE_ERRORS = `${prefix}/CHANGE_ROWS_PER_PAGE_RECAPTURE_ERRORS`;

export const changeRowsPerPageRecaptureErrors = (rowsPerPage) => ({
  type: CHANGE_ROWS_PER_PAGE_RECAPTURE_ERRORS,
  payload: rowsPerPage,
});

export const RESET_PAGE_RECAPTURE_ERRORS = `${prefix}/RESET_PAGE_RECAPTURE_ERRORS`;

export const resetPageRecaptureErrors = () => ({
  type: RESET_PAGE_RECAPTURE_ERRORS,
});

export const RESET_PAGE_RECAPTURE_FREEZES = `${prefix}/RESET_PAGE_RECAPTURE_FREEZES`;

export const resetPageRecaptureFreezes = () => ({
  type: RESET_PAGE_RECAPTURE_FREEZES,
});

export const fetchGroupRecaptureFreezes = makeApiActionCreatorV3(
  api.fetchGroupRecaptureFreezes,
  FETCH_GROUP_RECAPTURE_FREEZES[START],
  FETCH_GROUP_RECAPTURE_FREEZES[SUCCESS],
  FETCH_GROUP_RECAPTURE_FREEZES[ERROR],
);

export const CHANGE_PAGE_RECAPTURE_FREEZES = `${prefix}/CHANGE_PAGE_RECAPTURE_FREEZES`;

export const changePageRecaptureFreezes = (page) => ({
  type: CHANGE_PAGE_RECAPTURE_FREEZES,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE_RECAPTURE_FREEZES = `${prefix}/CHANGE_ROWS_PER_PAGE_RECAPTURE_FREEZES`;

export const changeRowsPerPageRecaptureFreezes = (rowsPerPage) => ({
  type: CHANGE_ROWS_PER_PAGE_RECAPTURE_FREEZES,
  payload: rowsPerPage,
});

export const undoGroupRecapture = makeApiActionCreatorV3(
  api.undoGroupRecapture,
  UNDO_GROUP_RECAPTURE[START],
  UNDO_GROUP_RECAPTURE[SUCCESS],
  UNDO_GROUP_RECAPTURE[ERROR],
);

export const createRollCorrGroup = makeApiActionCreatorV3(
  api.createRollCorrGroup,
  CREATE_ROLL_CORR_GROUP[START],
  CREATE_ROLL_CORR_GROUP[SUCCESS],
  CREATE_ROLL_CORR_GROUP[ERROR],
);

export const CHANGE_PAGE = `${prefix}/CHANGE_PAGE`;

export const changePage = (page) => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${prefix}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = (rowsPerPage) => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const FETCH_MASS_ROLL_CORRECTION_JOBS = createRequestTypes(
  `${prefix}/FETCH_MASS_ROLL_CORRECT`,
);

export const fetchMassRollCorrectionJobs = makeApiActionCreatorV3(
  api.fetchMassRollCorrectionJobs,
  FETCH_MASS_ROLL_CORRECTION_JOBS[START],
  FETCH_MASS_ROLL_CORRECTION_JOBS[SUCCESS],
  FETCH_MASS_ROLL_CORRECTION_JOBS[ERROR],
);

export const CREATE_MASS_ROLL_CORRECTION_JOB = createRequestTypes(
  `${prefix}/CREATE_MASS_ROLL_CORRECTION_JOB`,
);

export const createMassRollCorrectionJob = makeApiActionCreatorV3(
  api.createMassRollCorrectionJob,
  CREATE_MASS_ROLL_CORRECTION_JOB[START],
  CREATE_MASS_ROLL_CORRECTION_JOB[SUCCESS],
  CREATE_MASS_ROLL_CORRECTION_JOB[ERROR],
);

export const MASS_ROLL_CORR_JOB_VALIDATE_QUERY = createRequestTypes(
  `${prefix}/MASS_ROLL_CORR_JOB_VALIDATE_QUERY`,
);

export const massRollCorrJobValidateQuery = makeApiActionCreatorV3(
  api.massRollCorrJobValidateQuery,
  MASS_ROLL_CORR_JOB_VALIDATE_QUERY[START],
  MASS_ROLL_CORR_JOB_VALIDATE_QUERY[SUCCESS],
  MASS_ROLL_CORR_JOB_VALIDATE_QUERY[ERROR],
);

export const FETCH_MASS_ROLL_CORRECTION_JOB_ERRORS = createRequestTypes(
  `${prefix}/FETCH_MASS_ROLL_CORRECTION_JOB_ERRORS`,
);

export const fetchMassRollCorrectionJobErrors = makeApiActionCreatorV3(
  api.fetchMassRollCorrectionJobErrors,
  FETCH_MASS_ROLL_CORRECTION_JOB_ERRORS[START],
  FETCH_MASS_ROLL_CORRECTION_JOB_ERRORS[SUCCESS],
  FETCH_MASS_ROLL_CORRECTION_JOB_ERRORS[ERROR],
);

export const fetchMassRollCorrectionJobProperties = makeApiActionCreatorV3(
  api.fetchMassRollCorrectionJobProperties,
  FETCH_MASS_ROLL_CORRECTION_JOB_PROPERTIES[START],
  FETCH_MASS_ROLL_CORRECTION_JOB_PROPERTIES[SUCCESS],
  FETCH_MASS_ROLL_CORRECTION_JOB_PROPERTIES[ERROR],
);

export const fetchMassRollCorrectionJobProcessed = makeApiActionCreatorV3(
  api.fetchMassRollCorrectionJobProcessed,
  FETCH_MASS_ROLL_CORRECTION_JOB_PROCESSED[START],
  FETCH_MASS_ROLL_CORRECTION_JOB_PROCESSED[SUCCESS],
  FETCH_MASS_ROLL_CORRECTION_JOB_PROCESSED[ERROR],
);

export const FETCH_ROLL_CORR_AVAILABLE_YEARS = createRequestTypes(
  `${prefix}/FETCH_ROLL_CORR_AVAILABLE_YEARS`,
);

export const fetchRollCorrAvailableYears = makeApiActionCreatorV3(
  api.fetchRollCorrAvailableYears,
  FETCH_ROLL_CORR_AVAILABLE_YEARS[START],
  FETCH_ROLL_CORR_AVAILABLE_YEARS[SUCCESS],
  FETCH_ROLL_CORR_AVAILABLE_YEARS[ERROR],
);

export const FETCH_MASS_ROLL_CORRECTION_JOB_DETAIL = createRequestTypes(
  `${prefix}/FETCH_MASS_ROLL_CORRECTION_JOB_DETAIL`,
);

export const fetchMassRollCorrectionJobDetail = makeApiActionCreatorV3(
  api.fetchMassRollCorrectionJobDetail,
  FETCH_MASS_ROLL_CORRECTION_JOB_DETAIL[START],
  FETCH_MASS_ROLL_CORRECTION_JOB_DETAIL[SUCCESS],
  FETCH_MASS_ROLL_CORRECTION_JOB_DETAIL[ERROR],
);

export const FETCH_ROLL_CORR_MOVE_OPEN_APPEAL_HISTORY = createRequestTypes(
  `${prefix}/FETCH_ROLL_CORR_MOVE_OPEN_APPEAL_HISTORY`,
);

export const fetchRollCorrMoveOpenAppealHistory = makeApiActionCreatorV3(
  api.fetchRollCorrMoveOpenAppealHistory,
  FETCH_ROLL_CORR_MOVE_OPEN_APPEAL_HISTORY[START],
  FETCH_ROLL_CORR_MOVE_OPEN_APPEAL_HISTORY[SUCCESS],
  FETCH_ROLL_CORR_MOVE_OPEN_APPEAL_HISTORY[ERROR],
);

export const FETCH_ROLL_CORR_OPEN_APPEALS = createRequestTypes(
  `${prefix}/FETCH_ROLL_CORR_OPEN_APPEALS`,
);

export const fetchRollCorrOpenAppeals = makeApiActionCreatorV3(
  api.fetchRollCorrOpenAppeals,
  FETCH_ROLL_CORR_OPEN_APPEALS[START],
  FETCH_ROLL_CORR_OPEN_APPEALS[SUCCESS],
  FETCH_ROLL_CORR_OPEN_APPEALS[ERROR],
);

export const MOVE_ROLL_CORR_OPEN_APPEALS = createRequestTypes(
  `${prefix}/MOVE_ROLL_CORR_OPEN_APPEALS`,
);

export const moveRollCorrOpenAppeals = makeApiActionCreatorV3(
  api.moveRollCorrOpenAppeals,
  MOVE_ROLL_CORR_OPEN_APPEALS[START],
  MOVE_ROLL_CORR_OPEN_APPEALS[SUCCESS],
  MOVE_ROLL_CORR_OPEN_APPEALS[ERROR],
);

export const FETCH_ROLL_CORR_OPEN_GROUPS = createRequestTypes(
  `${prefix}/FETCH_ROLL_CORR_OPEN_GROUPS`,
);

export const fetchRollCorrOpenGroups = makeApiActionCreatorV3(
  api.fetchRollCorrOpenGroups,
  FETCH_ROLL_CORR_OPEN_GROUPS[START],
  FETCH_ROLL_CORR_OPEN_GROUPS[SUCCESS],
  FETCH_ROLL_CORR_OPEN_GROUPS[ERROR],
);

export const FETCH_ROLL_CORR_GROUP_ERRORS = createRequestTypes(
  `${prefix}/FETCH_ROLL_CORR_GROUP_ERRORS`,
);

export const fetchRollCorrOpenGroupErrors = makeApiActionCreatorV3(
  api.fetchRollCorrOpenGroupErrors,
  FETCH_ROLL_CORR_GROUP_ERRORS[START],
  FETCH_ROLL_CORR_GROUP_ERRORS[SUCCESS],
  FETCH_ROLL_CORR_GROUP_ERRORS[ERROR],
);
